<template>
   <main class="programma">
      <section>
         <div class="container pt-2 pb-4">
            <div class="row justify-content-between">
               <intro>
                  <template v-slot:title v-if="post">{{post.titolo}}</template>
                  <template v-slot:intro v-if="post"><vue-markdown>{{post.corpo}}</vue-markdown></template>
               </intro>
               <div class="col-12 col-md-4 mt-1">
                  <shareArea :url="this.$route.fullPath"></shareArea>
                  <miniMenu v-if="post && post.maggioriInfo.length > 0" :minimenu="post.maggioriInfo" :area="post.slug" :slug="post.slug" :_slug="post._slug"></miniMenu>
                  <!-- newsletter></newsletter -->
               </div>
            </div>
         </div>
      </section>

      <section class="section section-inset-shadow pb-0 pt-2 pb-5">
         <div id="content" class="container pt-2 pb-4 px-0 px-md-3 pt-5">
            <div class="row">
               <!-- Call cards -->                              
               <card-area v-for="(item) in subCategories" :key="`${item.id}`" :data="item" :area="item.area" :id="`${item.id}`" :noFooter="true">
                  <template v-slot:header>{{item.titolo}}</template>
                  {{item.breve}}
               </card-area>    
            </div>
         </div>
      </section>      
   </main>
</template>
<script>
import { getPage, getPages } from './../service';
import intro from "@/components/Intro";
import shareArea from "@/components/ShareArea";
import cardArea from "@/components/CardArea";
import miniMenu from "@/components/MiniMenu";
//import newsletter from "@/components/Newsletter";
import VueMarkdown from 'vue-markdown';


export default {
   name: "programma",   
   components: {
      VueMarkdown,
      intro,
      shareArea,
      cardArea,
      miniMenu,
      //newsletter,
   },
   title() {
      let pageTitle = this.$route.name;
      return pageTitle;
   },
   data() {
      return {
         post: null,
         subCategories: null
      }         
   },   
   methods: {
      loadPost: async function(id) {
         this.post = undefined;
         try {                     
            const result = await getPage(id, 'sezione');
            this.post = result
            //this.post = this.parseArticle(result);
         } catch (ex) {
            console.log('failed loadPost');
            this.post = null;
         }
      },

      loadSubcategories: async function(section){         
         try {
            let categories = await getPages(section);
            this.subCategories = categories.pages;
         } catch (ex) {
            console.log('failed loadSubcategories');
            this.post = null;
         }
      },

      /*parseArticle: function(response){
         return {
            id:            response.id,
            area:          response.schemaName,
            modified:      response.lastModified,
            titolo:        response.data.titolo.iv,
            breve:         response.data.breve.iv,
            corpo:         response.data.corpo.iv,
            maggioriInfo:  response.data.maggioriInformazioni.iv, 
            slug:          response.data.slug.iv
         }
      },*/

   },   

   created(){
      this.loadPost(this.$route.path.substring(+1));
      this.loadSubcategories(this.$route.name);
   },

   watch: {
      $route: {
         handler: function(to) {
            this.loadPost(to.params.id);
         }
      }
   },

};
</script>
